module.exports = __webpack_public_path__ + "img/bg-4@1000x-80-min.23ae47fb.webp";